import * as z from "zod";

export const saveIntelligentInventoryThread = {
  name: "saveIntelligentInventoryThread" as const,
  input: z.object({
    threadId: z.string(),
    saved: z.boolean().optional(),
    title: z.string().max(60).optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
